import { Document } from '@react-pdf/renderer'
import type { Client, Listing, ReportPdfOptions } from '~/models'
import {
  PdfDisclaimersPage,
  ReportPdfMapPage,
  ReportPdfTitlePage,
} from './pages'
import PdfListingTablePage from './pages/listing-table'

export default function ReportComparisonPdf({
  title,
  client,
  listings,
  pdfOptions,
}: {
  title: string
  client: Client
  listings: Listing[]
  pdfOptions: ReportPdfOptions
}) {
  return (
    <Document title={title}>
      {pdfOptions.showTitlePage && (
        <ReportPdfTitlePage
          title={title}
          listings={listings}
          pdfOptions={pdfOptions}
          orientation="portrait"
          client={client}
        />
      )}
      {pdfOptions.showMapPage && (
        <ReportPdfMapPage
          listings={listings}
          pdfOptions={pdfOptions}
          orientation="portrait"
        />
      )}
      <PdfListingTablePage listings={listings} />
      <PdfDisclaimersPage
        pdfOptions={pdfOptions}
        orientation="portrait"
        client={client}
      />
    </Document>
  )
}
